import { render, staticRenderFns } from "./HelpCenterView.vue?vue&type=template&id=08ea8aba&scoped=true"
import script from "./HelpCenterView.vue?vue&type=script&lang=js"
export * from "./HelpCenterView.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterView.vue?vue&type=style&index=0&id=08ea8aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea8aba",
  null
  
)

export default component.exports